import React from 'react';
import GenericSvgIcon from "./GenericSvgIcon";
import IconType from "@/types/Icon.type";

interface IconThumbProps extends IconType {
    thumbOrientation?: "up" | "down"
}

function IconThumb(props: IconThumbProps) {
    const {
        width = '20',
        height = '16',
        fill = '#070c63',
        viewBox = '0 0 20 20',
        title = 'IconTag',
        thumbOrientation = 'up',
        ...rest
    } = props

    const orientation = thumbOrientation === 'down' ? "rotate(-180deg)" : null;
    const style = {verticalAlign: 'middle', transform: `${orientation}`}

    return (
        <GenericSvgIcon
            width={width}
            height={height}
            viewBox={viewBox}
            title={title}
            {...rest}
            style={style}
            svgIconPath={(
                <g fill="none" transform="translate(2.268041)">
                    <path
                        d="m14.8659794 7.83505155h-2.5154639c-.4948454 0-.9072165-.41237114-.9072165-.9072165v-.41237113c.2886598-.72164949.5154639-1.44329897.6597938-2.18556701.0618557-.26804124.1030928-.53608248.1443299-.80412371l.1237113-.82474227c.1237114-.9072165-.5154639-1.73195876-1.4020618-1.8556701-.9072165-.12371134-1.7319588.51546391-1.85567014 1.40206185l-.12371134.82474227c-.39175258 2.78350515-1.93814433 5.25773196-4.24742268 6.82474227h-2.06185567-.41237113-2.26804124v8.24742268h2.68041237l1.93814433.7216495c.9072165.3298969 1.87628866.5154639 2.82474227.5154639h6.10309283c.9896907 0 1.8350515-.7010309 2-1.6701031l1.2577319-6.9896907.0824742-.4742268c.2268042-1.25773198-.742268-2.41237115-2.0206185-2.41237115z"
                    />
                    <g fill={fill}>
                        <path
                            d="m13.5257732 20h-6.1443299c-.98969072 0-1.93814433-.1649485-2.86597938-.5154639-.32989691-.1237114-.47422681-.4742268-.37113402-.8041237.12371134-.3298969.4742268-.4742268.80412371-.371134.78350515.2886597 1.58762886.4329896 2.43298969.4329896h6.1443299c.7010309 0 1.2989691-.4948453 1.4226804-1.1958762l1.3195876-7.4226805c.0824743-.41237109-.0412371-.84536078-.3092783-1.17525769-.2680413-.32989691-.6804124-.49484536-1.0927835-.49484536h-4.1443299c-.3505155 0-.6185567-.26804124-.6185567-.6185567 0-.35051547.2680412-.6185567.6185567-.6185567h4.1443299c.8041237 0 1.5463917.35051546 2.0618557.96907216.5154639.6185567.7216494 1.40206186.5773195 2.18556699l-1.3195876 7.4226804c-.2474227 1.2783505-1.3608247 2.2061856-2.6597938 2.2061856z"
                        />
                        <path
                            d="m2.68041237 18.7628866h-2.06185567c-.35051546 0-.6185567-.2680412-.6185567-.6185567s.26804124-.6185567.6185567-.6185567h1.44329897v-7.0103093h-1.44329897c-.35051546 0-.6185567-.2680412-.6185567-.61855668 0-.35051547.26804124-.6185567.6185567-.6185567h2.06185567c.35051547 0 .6185567.26804123.6185567.6185567v8.24742268c0 .3505155-.26804123.6185567-.6185567.6185567z"
                        />
                        <path
                            d="m4.74226804 10.5154639c-.20618557 0-.39175258-.1030928-.51546392-.2680412-.18556701-.28865981-.12371134-.65979383.16494846-.8659794 2.16494845-1.48453608 3.60824742-3.81443299 3.95876288-6.39175258l.12371134-.82474227c.08247423-.59793814.39175258-1.13402061.88659794-1.50515464.47422681-.37113402 1.07216496-.51546391 1.67010306-.43298969.5979382.08247423 1.1340207.39175258 1.5051547.88659794s.5154639 1.07216495.4329897 1.67010309l-.1237114.82474227c-.1237113.84536083-.3092783 1.6701031-.5773196 2.47422681-.1030927.3298969-.4536082.49484536-.7835051.39175257-.3298969-.10309278-.4948454-.45360824-.3917526-.78350515.2474227-.72164949.4123711-1.48453608.5154639-2.24742268l.1237114-.82474227c.0412371-.26804124-.0412372-.53608247-.2061856-.7628866-.1649485-.22680412-.4123711-.37113402-.6804124-.39175257-.2680412-.04123712-.5360824.04123711-.7628866.20618556-.2268041.16494846-.37113399.41237114-.39175255.68041237l-.12371134.82474227c-.41237113 2.92783505-2.04123711 5.56701031-4.49484536 7.25773197-.08247423.0412371-.20618557.0824742-.32989691.0824742z"
                        />
                    </g>
                </g>
              )}
        />

    );
}

export default IconThumb;
